import { MapProperty, MapZoomLevel } from '../enums';

const MapProps = {
  props: {
    [MapProperty.Width]: {
      type: Number,
      default: null,
    },
    [MapProperty.Height]: {
      type: Number,
      default: null,
    },
    [MapProperty.Zoom]: {
      type: Number,
      default: MapZoomLevel.XSmall,
    },
    [MapProperty.Center]: {
      type: Object,
      default: null,
    },
    [MapProperty.MarkersData]: {
      type: Array,
      default: () => ([]),
    },
    [MapProperty.Bounds]: {
      type: Object,
      default: null,
    },
    [MapProperty.DrawingArea]: {
      type: Object,
      default: null,
    },
    [MapProperty.DrawingOptions]: {
      type: Object,
      default: null,
    },
  },
};

export default MapProps;
